<template>
    <GenericMultiStepModal :header-icon="IconSource.Economy" :is-final-step="false" @closing="onModalClose">
        <template #default="scope">
            <slot v-bind="scope" />
        </template>
        <template #component="scope">
            <component :is="currentStep.component" v-model:entry="form" @submit="next" @close="scope.close"></component>
        </template>
    </GenericMultiStepModal>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue';
import GenericMultiStepModal from '@/components/common/GenericMultiStepModal.vue';
import DeleteSuccess from '@/views/dashboard/economy/economyBudget/editBudgetEntryModal/DeleteSuccess.vue';
import BudgetEntryPrices from '@/views/dashboard/economy/economyBudget/editBudgetEntryModal/BudgetEntryPrices.vue';
import { EconomyBudgetEntry } from '@/types';
import useResettableForm from '@/components/common/composables/useResettableForm';
import MultiStepFormHeaderIcon from '@/components/common/MultiStepFormHeaderIcon.vue';
import useMultiSteps from '@/components/common/composables/useMultiSteps';
import CloseModalButton from '@/components/common/CloseModalButton.vue';

export default defineComponent({
    components: { GenericMultiStepModal, MultiStepFormHeaderIcon, CloseModalButton },
    props: {
        entry: {
            type: Object as () => EconomyBudgetEntry,
            required: true,
        },
    },
    setup(props) {
        const resettableForm = useResettableForm().setInitial(props.entry);
        const form = resettableForm.getInstance();

        watch(
            () => props.entry,
            (newValue) => {
                if (newValue) {
                    resettableForm.setInitial(props.entry);
                }
            }
        );

        const multiSteps = useMultiSteps([
            {
                component: BudgetEntryPrices,
            },
            {
                component: DeleteSuccess,
            },
        ]).setInitial(0);

        const onModalClose = () => {
            multiSteps.reset();
            resettableForm.reset();
        };

        return {
            ...multiSteps,
            onModalClose,
            form,
        };
    },
});
</script>
